import React, { ReactElement, memo } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography, SvgIcon } from '@material-ui/core';
import {
  AccessTime,
  ArrowDropDownCircle,
  CheckBox,
  StarBorder,
  ThumbsUpDown,
  Title,
  AttachFile,
} from '@material-ui/icons';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';
import { ReactComponent as HashtagIcon } from '../../../../../assets/hash-24px.svg';
import { FieldType } from '../edit-field-dialog/edit-field-dialog-model';

function getFieldTypeLabel(type: FieldType) {
  const fieldTypeLabels = {
    VOLUNTEER_CheckboxFieldType: <FieldTypeLabel name='Checklist Item' Icon={<CheckBox />} />,
    VOLUNTEER_DropdownFieldType: <FieldTypeLabel name='Dropdown' Icon={<ArrowDropDownCircle />} />,
    VOLUNTEER_RatingFieldType: <FieldTypeLabel name='Rating' Icon={<StarBorder />} />,
    VOLUNTEER_BooleanFieldType: <FieldTypeLabel name='Thumbs Up/Down' Icon={<ThumbsUpDown />} />,
    VOLUNTEER_TimeFieldType: <FieldTypeLabel name='Time' Icon={<AccessTime />} />,
    VOLUNTEER_TextFieldType: <FieldTypeLabel name='Text' Icon={<Title />} />,
    VOLUNTEER_AttachmentFieldType: <FieldTypeLabel name='Attachment' Icon={<AttachFile />} />,
    VOLUNTEER_NumericFieldType: (
      <FieldTypeLabel
        name='Number'
        Icon={
          <SvgIcon>
            <HashtagIcon />
          </SvgIcon>
        }
      />
    ),
  };
  return fieldTypeLabels[type];
}

interface FieldTypeLabelProps {
  name: string;
  Icon: ReactElement;
}

const FieldTypeLabel = memo((props: FieldTypeLabelProps) => {
  const { name, Icon } = props;
  const { theme } = useCampfireTheme();
  const classes = makeStyles({
    field: {
      margin: 0,
      width: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
      minWidth: 200,
    },
    icon: {
      color: theme.palette.grey[800],
    },
  })();

  return (
    <Grid item container justify='flex-start' alignItems='center' spacing={1} className={classes.field}>
      <Grid item>{React.cloneElement(Icon, { className: classes.icon })}</Grid>
      <Grid item>
        <Typography variant='subtitle2' color='inherit'>
          {name}
        </Typography>
      </Grid>
    </Grid>
  );
});

export { FieldTypeLabel, getFieldTypeLabel };
